import { Maybe, Operation } from '../../../__generated__/globalTypes'

import {
  MinimalReminderFragment,
  minimalReminderFragmentString,
} from '../../fragments/__generated__/MinimalReminderFragment'

import getRemindersRawString from '../GetReminders.graphql'

const getRemindersString = [
  getRemindersRawString,
  minimalReminderFragmentString,
].join('\n\n')

export type GetRemindersData = {
  reminders: MinimalReminderFragment[]
}

export type GetRemindersVariables = {
  offset?: Maybe<number>
  limit?: Maybe<number>
}

export type GetReminders = Operation<GetRemindersData, GetRemindersVariables>

export const GetReminders = ({
  offset,
  limit,
}: GetRemindersVariables = {}): GetReminders => ({
  query: getRemindersString,
  variables: {
    offset,
    limit,
  },
})
